import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import DetailedSpecs from '../components/DetailedSpecs';

class WidgetContainer extends React.Component {
	render() {
		let rootComponent;
		if (this.props.equipment) {
			const { specCategories, specification } = this.props.equipment;
			const { prefs, widgetInfo } = this.props;

			rootComponent = (
				<DetailedSpecs
					specCategories={specCategories}
					specification={specification}
					widgetInfo={widgetInfo}
					prefs={prefs}
				/>
			);
		}
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	equipment: PropTypes.shape({
		specCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
		specification: PropTypes.arrayOf(PropTypes.object).isRequired
	}),
	prefs: PropTypes.objectOf(PropTypes.string),
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired
};

WidgetContainer.defaultProps = {
	equipment: {},
	prefs: {}
};

const mapStateToProps = state => ({
	prefs: state.prefs,
	equipment: state.equipment,
	widgetInfo: state.widgetInfo
});

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;
